<form action="">
    <div class="row">
        <div class="col-12">FirstName</div>
        <dx-text-box class="col-12 m-2" [(value)]="admin.firstName"></dx-text-box>
    </div>
    <div class="row">
        <div class="col-12">LastName</div>
        <dx-text-box class="col-12 m-2" [(value)]="admin.lastName" ></dx-text-box>
    </div>
    <div class="row">
        <div class="col-12">Email</div>
        <dx-text-box class="col-12 m-2" [(value)]="admin.email"></dx-text-box>
    </div>
    <div class="row">
        <div class="col-12">Phone</div>
        <dx-text-box class="col-12 m-2" [(value)]="admin.phone"></dx-text-box>
    </div>
    <div class="row mb-2 mt-2" *ngIf="user && !user.admin">
        <div class="col-4">Account access</div>
        <div class="col-2">
            <dx-switch switchedOnText="Yes" switchedOffText="No" [(value)]="admin.isActive"></dx-switch>
        </div>
    </div>
    <div class="row">
        <div class="col-6"></div>
        <div class="col-6">
            <dx-button class="w-100 h-100" type="success" (onClick)="onSaveHandler()">
                Save
            </dx-button>
        </div>
    </div>
</form>